<template>
    <div class="w-11/12 sm:w-3/5 md:w-2/3 xl:w-2/5 xxl:w-1/3 m-auto mb-12">
        <a href="/">
            <img src='assets/img/nesst-logo.svg' alt="NESst-logo" class="w-20 md:w-32 py-6 text-center m-auto">
        </a>
        <div class="questionnaire-wrapper flex flex-col bg-white p-4 sm:p-6 md:px-10">
            <loader v-if="loading" class="m-auto"/>
            <div v-else-if="message" class="flex flex-col flex-1 justify-center">
                <h3 class="relative text-xl sm:text-2xl lg:text-3xl leading-tight md:leading-normal font-bold text-muted-500 text-center">{{ message }}</h3>
            </div>
            <div v-else class="flex flex-col flex-1">
                <h3 class="relative text-xl sm:text-2xl lg:text-3xl font-bold text-muted-500 text-center mb-5">Login</h3>
                <div class="flex flex-col flex-1 justify-center">
                    <question-email
                        :question="question"
                        :required="true"
                        ref="questionComponent"
                        @input="email = $event"
                    />
                    <div v-if="errorMessage"
                         class="progress relative w-full bg-risk-400 rounded-full text-center text-base md:text-2xl py-1 sm:py-2 md:py-3 pl-6 my-8 md:my-12 self-start text-light-100">
                        {{ errorMessage }}
                    </div>
                </div>
                <div class="w-full flex justify-end mt-6 md:mt-12">
                    <button type="button" @click="authenticate"
                            class="text-base md:text-2xl lg:text-3xl bg-lightGreen-100 hover:bg-lightGreen-200 text-lightGreen-300 font-bold py-1 sm:py-2 px-10 sm:px-12 md:px-16 lg:px-20 rounded-full">
                        Next
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { firebase } from '../../firebase';
    import Loader from '../shared/Loader';
    import QuestionEmail from '../questions/QuestionEmail';

    export default {
        components: {QuestionEmail, Loader},

        data() {
            return {
                loading: true,
                email: null,
                message: null,
                errorMessage: null,
            }
        },

        computed: {
            question() {
                return {
                    'en': 'Your Email Address',
                    'es': 'Dirección de correo electrónico',
                };
            }
        },

        methods: {
            authenticate() {
                if (!this.validate()) {
                    return;
                }

                const email = this.email[0].value;

                firebase.auth().sendSignInLinkToEmail(email, {
                    url: window.location.href,
                    handleCodeInApp: true,
                }).then(() => {
                    this.message = 'Check your email inbox for authentication link';
                    localStorage.email = email;
                }).catch(error => console.error(error));
            },

            validate() {
                return this.$refs.questionComponent.validate();
            },
        },

        created() {
            let returnUrl = decodeURIComponent(this.$route.query.return);
            if (returnUrl && returnUrl !== 'undefined') {
                localStorage.setItem('returnUrl', returnUrl);
            }

            if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
                let email = localStorage.getItem('email');
                if (!email) {
                    email = window.prompt('Please provide your email for confirmation');
                }
                firebase.auth().signInWithEmailLink(email, window.location.href)
                    .then(result => {
                        localStorage.removeItem('email');
                        window.location.href = 'questionnaire';
                    })
                    .catch(error => console.error(error));
            }

            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    let uri = 'questionnaire';

                    if (localStorage.getItem('returnUrl')) {
                        uri = localStorage.getItem('returnUrl');
                        localStorage.removeItem('returnUrl');
                    }

                    window.location.href = uri;
                } else {
                    setTimeout(() => {
                        this.loading = false
                    }, 2000);
                }
            });
        },
    };
</script>
